// import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import EditableDatable from "./EditableDatatable";
import {
  prequalificationLineswithoutcompany,
  productCategories,
  token,
  companyDefault,
  uOMApi,
  Manufacturers,
  Brands,
} from "../HelperFx/datalinks";
import useFetch from "../utils/UseFetch";
import axios from "axios";

const PrequalificationLines = ({ docNo, Status }) => {
  const [fdata, setData] = useState([]);
  const apiUrl = `${prequalificationLineswithoutcompany}?${companyDefault}&$filter = documentNo eq '${docNo}'`;
  const { data: fetchedData } = useFetch(apiUrl, token);
  const { data: ProductCategories } = useFetch(productCategories, token);
  const { data: UOMData } = useFetch(uOMApi, token);
  const { data: BrandsData } = useFetch(Brands, token);
  const { data: ManufacturersData } = useFetch(Manufacturers, token);
  // const { data: fetchedData, loading, error } = useFetch(apiUrl, base64backendtoken);
  const fetchedDataItems = fetchedData?.value;
  const lvProductCategories = ProductCategories?.value;
  const lvUOMData = UOMData?.value;
  const BrandsdataApi = BrandsData?.value;
  const ManufacturersApi = ManufacturersData?.value;
  // console.log(fetchedDataItems)
  console.log(docNo);

  useEffect(() => {
    if (fetchedDataItems) {
      setData(fetchedDataItems);
    }
  }, [fetchedDataItems]);

  const handlePageBlur = async (id, field, value, updated) => {
    const row = updated.find((r) => r.systemId === id);

    if (!row) return;

    if (!row.systemId || row.systemId.trim() === "") {
      console.warn("Skipping save. systemId is empty for row:", row);
      return;
    }

    try {
      if (
        row.systemId.startsWith("empty") &&
        (row.systemSerialId === null ||
          row.systemSerialId === undefined ||
          row.systemSerialId === "")
      ) {
        // 🔹 INSERT (new record)
        const insertPayload = {
          documentNo: docNo,
          productCategory: row.productCategory,
        };
        if (!insertPayload.productCategory) {
          console.warn("Skipping insert. Required fields missing:", {
            productCategory: insertPayload.productCategory,
          });
          return; // exit early, don’t insert
        }
        console.log("Inserting new row:", insertPayload);

        const response = await axios.post(
          `${prequalificationLineswithoutcompany}?${companyDefault}`,
          insertPayload,
          {
            headers: {
              Authorization: `Basic ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        console.log(response);

        // Set the new record data
        const newRow = await response.data;
        newRow.systemSerialId = newRow.systemId;
        newRow.systemId = id;
        updated = updated
          .filter((r) => r.systemId !== row.systemId)
          .concat({ ...newRow });

        setData(updated);
        // window.location.reload();
      } else {
        // 🔹 PATCH (update existing record with concurrency check)
        const patchPayload = {
          [field]: value, // only update the changed field
        };

        console.log("Patching row:", row.systemId, patchPayload);
        let ssid = "";

        if (row.systemSerialId) {
          ssid = row.systemSerialId;
        } else ssid = row.systemId;

        const response = await axios.patch(
          `${prequalificationLineswithoutcompany}(${ssid})?${companyDefault}`,
          patchPayload,
          {
            headers: {
              Authorization: `Basic ${token}`,
              "Content-Type": "application/json",
              "If-Match": "*",
              // 👆 send etag if available, else allow overwrite with "*"
            },
          }
        );
        const prequalificationData = await response.data;
        prequalificationData.systemSerialId = prequalificationData.systemId;
        prequalificationData.systemId = id;
        // updated = updated.filter(r => r.systemId !== row.systemId).concat({ ...prequalificationData});

        updated = updated.map((r) =>
          r.systemId === row.systemId ? { ...prequalificationData } : r
        );
        console.log(updated);

        setData(updated);

        // setData(updated);
      }
    } catch (error) {
      console.error("Error saving row:", error.response?.data || error.message);
    }
  };

  const colToUse = [
    {
      label: "Product Category",
      type: "select",
      options:
        lvProductCategories?.map((prod) => ({
          value: prod.code,
          label: `${prod.code}-${prod.description}`,
        })) || [],
      name: "productCategory",
      tabIndex: 0,
      sortable: true,
      grow: 2,
      disabled: Status === "Sent",
    },
    {
      label: "Product Description",
      type: "text",
      name: "productCatDescription",
      tabIndex: 0,
      sortable: true,
      width: "150px",
      disabled: true,
    },
    {
      label: "Description",
      type: "text",
      name: "description",
      tabIndex: 0,
      sortable: true,
      width: "150px",
      disabled: Status === "Sent",
    },

    {
      label: "Does Manufacturere Exist",
      type: "select",
      name: "doesManufacturerExistInSys",
      tabIndex: 0,
      sortable: true,
      width: "150px",
      disabled: Status === "Sent",
      options: [
        { label: "No", value: "No" },
        { label: "Yes", value: "Yes" },
      ],
    },
    {
      label: "Manufacturer",
      type: "text",
      name: "manufacturer",
      tabIndex: 0,
      sortable: true,
      width: "150px",
      disabled: Status === "Sent",
    },
    {
      label: "Manufacturer Code",
      type: "select",
      options:
        ManufacturersApi?.map((prod) => ({
          value: prod.code,
          label: `${prod.code}-${prod.Name}`,
        })) || [],

      name: "manufacturerCode",
      tabIndex: 0,
      sortable: true,
      width: "150px",
      disabled: Status === "Sent",
    },
    {
      label: "Does Brand Exist",
      type: "select",
      name: "doesBrandExist",
      tabIndex: 0,
      sortable: true,
      width: "150px",
      disabled: Status === "Sent",
      options: [
        { label: "No", value: "No" },
        { label: "Yes", value: "Yes" },
      ],
    },
    {
      label: "Brand Code",
      type: "select",
      name: "brandCode",
      tabIndex: 0,
      sortable: true,
      width: "150px",
      disabled: Status === "Sent",
      options:
        BrandsdataApi?.map((prod) => ({
          value: prod.code,
          label: `${prod.code}-${prod.Name}`,
        })) || [],
    },
    {
      label: "Brand Name",
      type: "text",
      name: "brandName",
      tabIndex: 0,
      sortable: true,
      width: "150px",
      disabled: Status === "Sent",
    },
    {
      label: "Does Unit Of Measure Exist InSys",
      type: "select",
      name: "doesUnitOfMeasureExistInSys",
      tabIndex: 0,
      sortable: true,
      width: "150px",
      disabled: Status === "Sent",
      options: [
        { label: "No", value: "No" },
        { label: "Yes", value: "Yes" },
      ],
    },
    {
      label: "UOM Code",
      type: "select",
      options:
        lvUOMData?.map((prod) => ({
          value: prod.Code,
          label: `${prod.Code}-${prod.Description}`,
        })) || [],
      name: "UOMCode",
      tabIndex: 0,
      sortable: true,
      width: "150px",
      disabled: Status === "Sent",
    },
    {
      label: "UOM Description",
      type: "text",
      name: "UOMDescription",
      tabIndex: 0,
      sortable: true,
      width: "150px",
      disabled: Status === "Sent",
    },
    {
      label: "Pack Size",
      type: "text",
      name: "packSize",
      tabIndex: 0,
      sortable: true,
      width: "150px",
      disabled: Status === "Sent",
    },
  ];
  // const onPageBlur = (id, key, value) =>{

  // }
  return (
    <EditableDatable
      linesApi={prequalificationLineswithoutcompany}
      initialData={fdata}
      columns={colToUse}
      pageOnBlur={handlePageBlur}
      converteddocType={50024}
      ShowActions={Status === "Open"}
    />
  );
};

export default PrequalificationLines;
